import { readPdfLicensePolicy, type PdfPreviewKind } from "./PdfLicensePolicy";

/** Finalizes chapter content before download or merging; licensed documents retain their original bytes. */
export async function protectPdfOutput(blob: Blob, kind: PdfPreviewKind): Promise<Blob> {
  const policy = readPdfLicensePolicy(globalThis.state?.projectLicense);
  if (!policy.preview) return blob;
  const { createPdfLicensePreview } = await import("./createPdfLicensePreview");
  try {
    return await createPdfLicensePreview(blob, kind, policy);
  } catch (error) {
    throw new Error(`PDF-Lizenzvorschau (${kind}): ${error instanceof Error ? error.message : String(error)}`, { cause: error });
  }
}
